export default __webpack_public_path__ + "static/community_2-9ed8094646bd7b55ebe86ccfb9b58833.jpg";